export const API_URI = 'https://mydynasty.ca/cd/api/v1';
// export const API_URI = 'http://127.0.0.1:8000/cd/api/v1';
